/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"
import { WidgetStyle } from "../../util/Styles";
import { PrecisionManufacturing } from "@mui/icons-material";
import { Card, Grid, Typography, Tabs, Tab, Box } from "@mui/material";

const ServiceManager = (props) => {
  const [tabActive, setTabActive] = useState("FEATURES");
  const [content, setContent] = useState({});
  const [item, setItem] = useState(props.item);
  const [tabs] = useState([
    {name: "FEATURES", title: "Features" },
    {name: "MINIBUS", title: "SkyNet" },
  ]);

  const updateItem = (item) => {
    const content = {};
    for (let i in item.data.content) {
      if (!content[item.data.content[i].type]) {
        content[item.data.content[i].type] = [];
      }
      content[item.data.content[i].type].push(item.data.content[i]);
    }
    setContent(content);
    setItem(item);
    return content;
  };

  useEffect(() => {
    if (props.next === "update") {
      props.updateNext(null);
      setItem(props.item);

      if (!item.data.content["feature"] && !item.data.content["minibus"]) {
        const content = updateItem(props.item);
        changeTab("FEATURES", content);
      }
    }
  }, [props.next]);

  const changeTab = (tab: string, content) => {
    var type;
    if (tab === "FEATURES") {
      type = "feature";
    } else {
      type = "minibus";
    }
    item.data.content = content[type];
    setTabActive(tab);
  };

  function findActiveTab(item) { 
    return item.name === tabActive;
  }

  return (
    <WidgetStyle property={String(false)}>
      <ThemeProvider theme={theme}>
        <Grid container>
          <Card sx={{width: '100% !important', padding: 4}}>
            <Box>
              <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}} fontWeight={600}>
                <PrecisionManufacturing sx={{ marginRight: 1 }}/> Administrador SkyNet
              </Typography>
              <Box mb={4} ml={4} sx={{fontStyle: "italic", fontWeight: "500 !important"}} >
                Activación / Desactivación Global
              </Box>
            </Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
              <Tabs value={tabs.findIndex(findActiveTab)}>
                {tabs.map((item, index) => {
                  return <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.name, content)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 18}} />
                })}
              </Tabs>
            </Box>
          
            <FeatureList
              next={props.next}
              updateNext={props.updateNext}
              item={item}
              updateItem={updateItem}
              addWidget={props.addWidget}
              key={props.index}
              openModal={props.openModal}
              changeOpenModal={props.changeOpenModal}
              contentModal={props.contentModal}
              changeContentModal={props.changeContentModal}
              changeAlert={props.changeAlert}
              changeLoader={props.changeLoader}
              pos={props.pos}
            />
          </Card>
        </Grid>
      </ThemeProvider>
    </WidgetStyle>
  );
};

const FeatureList = (props) => {
  const [state, setState] = useState({});
  const [item, setItem] = useState(props.item);
  const history = useHistory();

  useEffect(() => {
    if (props.next === "update") {
      props.updateNext(null);
      setItem(props.item);
    }
    var state = { tableCheckbox: false };
    for (let i = 0; i < item.data.content.length; i++) {
      state[item.data.content[i].name] = item.data.content[i].active;
    }

    setState(state);
  }, [item, props.next]);

  const handleToogle = async (data) => {
    setState({ ...state, [data.name]: !state[data.name] });
    data.active = !data.active;
    await submit(data);
  };

  const submit = async (data) => {
    props.changeLoader(true);

    let request = await API.service( "managerStatusUpdate", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      props.changeAlert(true, "success", "Datos actualizados con éxito");
    } else {
      setState({ ...state, [data.name]: !data.active });
      data.active = !data.active;
    }
    reload();
  };

  const reload = async () => {
    let request = await API.service( "serviceManagerGet", props.item.data.requestData, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200) {
      let widg = request.data.data.widget;
      props.updateItem(widg[0]);
    }
    props.changeLoader(false);
  };

  const columns = [
    { selector: (row) => row.name, name: "Nombre", width: "40%", sortable: true },
    { cell: (row) => {
      return (
        <div className={`switcher ${row.active ? 'active' : ''}`} onClick={handleToogle.bind(this, row)}>
          <div className="switcherSlider">
            <div className="switcherSliderCircle"></div>
          </div>         
        </div>
      )
    }, 
    width: "30%", sortable: true, name: "Activar / Desactivar", center: true },   
  ];

  return (
    <DataTable
      columns={columns}
      data={item.data.content}
      customStyles={customStyles2}
      noDataComponent={noDataComponent}
    />
  );
};

export default ServiceManager;
